<template>

 <div class="cell">
      <!-- <div class="cell"> -->
    <div style="position: relative;height:100px;margin-bottom:10px"> 
     <div class="qlargecircularimage qheadercolour" style="position:absolute;left:5px;top:0px" v-if="$mq != 'sm'"><img style="height:45px;width:45px" src="/assets/icons/betfinder.png"/></div>
        <h1 class="cell auto text-center qmajorheader" v-if="searchtype=='full'">{{ langConv('Bet Finder') }}</h1>
        <h2 class="qsubheader" v-if="searchtype=='full'" style="padding: 10px 0px 10px 0px">{{ langConv('Check out our past bets in charts or downloadable text to improve your betting strategy') }}</h2>
      </div> 
    <!-- </div> -->
  
    <!-- </div> -->
     
  <div class="filter-app">
    <!-- Compact Filter Bar -->
    <div class="filter-bar">
      <div class="filter-header">
        <div class="filter-title">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3"></polygon>
          </svg>
          <span>Betting Filters</span>
          <span v-if="activeFilterCount" class="filter-count">{{ activeFilterCount }}</span>
        </div>
        
        <div class="filter-actions">
          <button @click="applyFilters" :disabled="isLoading" class="icon-btn apply" title="Apply filters">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </button>
          <button @click="clearFilters" class="icon-btn" title="Clear all filters">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>
      
      <!-- Active Filter Chips -->
      <div class="filter-chips" v-if="activeFilterCount">
        <div v-for="criterion in activeCriteria" :key="criterion.id" class="filter-chip">
          <span class="chip-label">{{ getShortFilterDescription(criterion) }}</span>
          <button @click="removeCriterionAndRefresh(criterion.id)" class="chip-remove">×</button>
        </div>
        <button @click="clearFilters" class="clear-all">Clear all</button>
      </div>
      
      <!-- Collapsible Filter Builder -->
      <div class="filter-builder">
        <button @click="toggleExpanded" class="toggle-builder">
          {{ isExpanded ? '− Hide filters' : '+ Add filter' }}
        </button>
        
        <div v-show="isExpanded" class="builder-content">
          <div v-for="(criterion, index) in displayCriteria" :key="criterion.id" class="filter-row">
            <span v-if="index > 0" class="logic-badge" :class="criterion.logicalOperator.toLowerCase()">
              {{ criterion.logicalOperator }}
            </span>
            
            <div class="filter-controls">
              <select v-model="criterion.filterType" class="compact-select filter-type">
                <option value="standard">Event Information</option>
                <option value="odds">Odds Condition</option>
                <option value="bookmaker">Bookmaker</option>
                <option value="event">Event Property</option>
              </select>
              
              <!-- Event Information Filter -->
              <template v-if="criterion.filterType === 'standard'">
                <select v-model="criterion.field" @change="onFieldChange(criterion)" class="compact-select field">
                  <option value="startTime">Start Time</option>
                  <option value="competitorName">Competitor Name</option>
                  <option value="sport">Sport</option>
                  <option value="league">League</option>
                </select>
                
                <!-- Start Time specific controls -->
                <template v-if="criterion.field === 'startTime'">
                  <select v-model="criterion.operator" class="compact-select operator">
                    <option value="after">After</option>
                    <option value="before">Before</option>
                  </select>
                  
                  <div class="value-container">
                    <input v-model="criterion.value" type="datetime-local" class="compact-input" />
                  </div>
                </template>
                
                <!-- Sport specific controls (multi-select) -->
                <template v-else-if="criterion.field === 'sport'">
                  <div class="value-container multi-select">
                    <select v-model="criterion.sportIds" multiple size="3" class="compact-select multi">
                      <option v-for="sport in getSportsList()" :key="sport.id" :value="sport.id">
                        {{ sport.name }}
                      </option>
                    </select>
                    <small class="hint">Ctrl+Click to select multiple sports</small>
                  </div>
                </template>
                
                <!-- Other fields (Event Name, League) -->
                <template v-else>
                  <select v-model="criterion.operator" class="compact-select operator">
                    <option value="contains">contains</option>
                    <option value="equals">=</option>
                    <option value="notEquals">≠</option>
                    <option value="startsWith">starts with</option>
                  </select>
                  
                  <div class="value-container">
                    <input v-model="criterion.value" type="text" placeholder="Value..." class="compact-input" />
                  </div>
                </template>
              </template>
              
              <!-- Odds Filter - Simplified (no bookmaker selection) -->
              <template v-else-if="criterion.filterType === 'odds'">
                <select v-model="criterion.oddsOperator" class="compact-select operator">
                  <option value="greaterThan">&gt;</option>
                  <option value="greaterThanOrEqual">≥</option>
                  <option value="lessThan">&lt;</option>
                  <option value="lessThanOrEqual">≤</option>
                  <option value="equals">=</option>
                </select>
                
                <div class="value-container">
                  <input v-model.number="criterion.oddsValue" type="number" step="0.5" placeholder="Odds value" class="compact-input" />
                </div>
              </template>
              
              <!-- Bookmaker Filter -->
              <template v-else-if="criterion.filterType === 'bookmaker'">
                <select v-model="criterion.bookmakerOperator" class="compact-select operator">
                  <option value="any">Any of</option>
                  <option value="all">All of</option>
                  <option value="exclude">Exclude</option>
                </select>
                
                <div class="value-container multi-select">
                  <select v-model="criterion.bookmakerIds" multiple size="3" class="compact-select multi">
                    <option v-for="bookmaker in getBookmakersList()" :key="bookmaker.id" :value="bookmaker.id">
                      {{ bookmaker.name }}
                    </option>
                  </select>
                  <small class="hint">Ctrl+Click to select multiple</small>
                </div>
              </template>
              
              <!-- Event Property Filter - Only "Number of Bookmakers" -->
              <template v-else-if="criterion.filterType === 'event'">
                <select v-model="criterion.eventOperator" class="compact-select operator">
                  <option value="greaterThan">&gt;</option>
                  <option value="greaterThanOrEqual">≥</option>
                  <option value="lessThan">&lt;</option>
                  <option value="lessThanOrEqual">≤</option>
                  <option value="equals">=</option>
                </select>
                
                <div class="value-container">
                  <input v-model.number="criterion.numBookmakersValue" type="number" placeholder="Number of bookmakers" class="compact-input" />
                </div>
              </template>
              
              <button @click="removeCriteriaRow(index)" class="remove-chip" v-if="displayCriteria.length > 1">
                ×
              </button>
            </div>
          </div>
          
          <button @click="addCriteriaRow" class="add-filter-btn">
            + Add condition
          </button>
          
          <div class="builder-actions">
            <button @click="applyFilters" class="btn-primary">Apply</button>
            <button @click="cancelFilters" class="btn-secondary">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Results Summary -->
    <div class="results-header">
      <div class="results-info">
        <strong>{{ filteredData.length }}</strong> events found
        <span v-if="lastFilterTime" class="result-time">({{ lastFilterTime }}ms)</span>
      </div>
    </div>
    
    <!-- Data Grid -->
    <div class="data-container">
      <div v-if="isLoading" class="loading-state">
        <div class="spinner-small"></div>
        <span>Filtering events...</span>
      </div>
      
      <div v-else-if="filteredData.length" class="table-wrapper">
        <table class="data-grid">
          <thead>
            <tr>
              <th>Start Time</th>
              <th>Sport</th>
              <th>League</th>
              <th>Event</th>
              <th>Bet Type</th>
            </tr>
          </thead>
          <tbody>
           
            
      <tr 
        v-for="row in filteredData" 
        :key="row.id"
        is="router-link"
        :to="$URLCreateTS('Event', row.sport, row.country, row.league, row.event, row.bettype, row.tpoid, row.compid)"
        tag="tr"
      >
              
              <td data-label="Start Time">{{ formatDateTime(row.startdate) }}</td>
              <td data-label="Sport">{{ row.sport }}</td>
              <td data-label="League">{{ row.league }}</td>
              <td data-label="Event">
                <strong>{{ row.event }}</strong>
              </td>
              <td data-label="Bet Type">{{ row.bettype }}</td>
              
              
            </tr>
            
          </tbody>
        </table>
      </div>
      
      <div v-else class="empty-state">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <p>No events found</p>
        <small>Try adjusting your filters</small>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'BettingFilterBuilder',
    metaInfo() {
      
        const baseUrl = process.env.VUE_APP_WEBSITE || ''
        const path = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/'     
        return {
            title: "BetFinder | Oddsgalore",
            meta: [{
        
                vmid: 'description',
                name: 'description',
                content: 'Odds for ' + this.$spaceandclean(this.competitors)
            },
            {
                vmid: 'og:title',
                property: 'og:title',
                content: 'Odds for '+ this.$spaceandclean(this.competitors) +  ' | Oddsgalore'
            }
            ],
            link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: baseUrl + path
            }]
        }
        },
  props: {
    searchtype: {
      type: String,
      default: 'full'
    }
  },
  data() {
    return {
      // WCF Service configuration
      wcfUrl: process.env.VUE_APP_WEBAPI + 'FeatureTables.svc/RetrieveGenericPost',
      
      activeCriteria: [],
      displayCriteria: [],
      filteredData: [],
      isLoading: false,
      lastFilterTime: null,
      isExpanded: false,
      
      // Local cache for bookmakers
      bookmakersCache: [],
      // Local cache for sports
      sportsCache: []
    }
  },
  
  computed: {
    activeFilterCount() {
      return this.activeCriteria.filter(this.isCriterionValid).length
    }
  },
  
  mounted() {
    // Load bookmakers and sports from store when component mounts
    this.loadBookmakersFromStore()
    this.loadSportsFromStore()
  },
  
  created() {
    this.initCriteria()
  },
  
  methods: {
    langConv(key) {
      // Your language conversion method
      return key
    },
    
    // Load bookmakers from Vuex store safely
    loadBookmakersFromStore() {
      try {
        if (this.$store && this.$store.state && this.$store.state.sb) {
          const bookmakers = this.$store.state.sb
          if (Array.isArray(bookmakers)) {
            this.bookmakersCache = bookmakers.map(function(bm) {
              return {
                id: bm.v,
                name: bm.D
              }
            })
          } else {
            console.warn('Bookmakers data is not an array:', bookmakers)
            this.bookmakersCache = []
          }
        } else {
          console.warn('Vuex store or state.sb not available')
          this.bookmakersCache = []
        }
      } catch (error) {
        console.error('Error loading bookmakers from store:', error)
        this.bookmakersCache = []
      }
    },
    
    // Load sports from Vuex store
    loadSportsFromStore() {
      try {
        if (this.$store && this.$store.state && this.$store.state.sports) {
          const sports = this.$store.state.sports
          if (Array.isArray(sports)) {
            this.sportsCache = sports.map(function(s) {
              return {
                id: s.v,
                name: s.D
              }
            })
            console.log('Sports loaded:', this.sportsCache)
          } else {
            console.warn('Sports data is not an array:', sports)
            this.sportsCache = []
          }
        } else {
          console.warn('Vuex store or state.sports not available')
          this.sportsCache = []
        }
      } catch (error) {
        console.error('Error loading sports from store:', error)
        this.sportsCache = []
      }
    },
    
    // Get bookmakers list
    getBookmakersList() {
      return this.bookmakersCache
    },
    
    // Get sports list
    getSportsList() {
      return this.sportsCache
    },
    
    // Get bookmaker name by ID
    getBookmakerNameById(id) {
      const found = this.bookmakersCache.find(function(b) { 
        return b.id === id 
      })
      return found ? found.name : id
    },
    
    // Get sport name by ID
    getSportNameById(id) {
      const found = this.sportsCache.find(function(s) { 
        return s.id === id 
      })
      return found ? found.name : id
    },
    
    // Reset criterion values when field changes
    onFieldChange(criterion) {
      // Reset sportIds for all fields
      criterion.sportIds = []
      
      if (criterion.field === 'startTime') {
        criterion.operator = 'after'
        criterion.value = this.getDefaultDateTime()
      } else if (criterion.field === 'sport') {
        criterion.operator = 'contains'
        criterion.value = ''
      } else {
        // For competiorName and league
        criterion.operator = 'contains'
        criterion.value = ''
      }
    },
    
    initCriteria() {
      this.activeCriteria = []
      this.displayCriteria = [this.createEmptyCriterion()]
    },
    
    createEmptyCriterion() {
      return {
        id: this.generateId(),
        filterType: 'standard',
        logicalOperator: 'AND',
        field: 'startTime',
        operator: 'after',
        value: this.getDefaultDateTime(),
        sportIds: [],
        oddsOperator: 'greaterThan',
        oddsValue: null,
        bookmakerOperator: 'any',
        bookmakerIds: [],
        eventOperator: 'greaterThan',
        numBookmakersValue: null,
        booleanValue: true
      }
    },
    
    getDefaultDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    },
    
    generateId() {
      return Date.now() + '-' + Math.random().toString(36).substr(2, 6)
    },
    
    getShortFilterDescription(criterion) {
      if (!criterion || !this.isCriterionValid(criterion)) return ''
      
      // Define operatorMap once at the beginning
      var operatorMap = {
        'greaterThan': '>',
        'greaterThanOrEqual': '≥',
        'lessThan': '<',
        'lessThanOrEqual': '≤',
        'equals': '='
      }
      
      if (criterion.filterType === 'odds') {
        return 'Odds ' + operatorMap[criterion.oddsOperator] + ' ' + criterion.oddsValue
      }
      
      if (criterion.filterType === 'bookmaker') {
        var opText = criterion.bookmakerOperator === 'any' ? 'includes' : criterion.bookmakerOperator
        var self = this
        var bookmakerNames = criterion.bookmakerIds.map(function(id) { 
          return self.getBookmakerNameById(id) 
        })
        return 'Bookmakers ' + opText + ': ' + bookmakerNames.join(', ')
      }
      
      if (criterion.filterType === 'event') {
        return 'Number of bookmakers ' + operatorMap[criterion.eventOperator] + ' ' + criterion.numBookmakersValue
      }
      
      if (criterion.filterType === 'standard') {
        if (criterion.field === 'startTime') {
          const operatorText = criterion.operator === 'before' ? 'before' : 'after'
          const dateTime = criterion.value.replace('T', ' ')
          return `Start time ${operatorText} ${dateTime}`
        }
        if (criterion.field === 'sport') {
          if (criterion.sportIds && criterion.sportIds.length > 0) {
            const self = this
            const sportNames = criterion.sportIds.map(function(id) { 
              return self.getSportNameById(id) 
            })
            return `Sport in: ${sportNames.join(', ')}`
          }
        }
        return criterion.field + ' ' + criterion.operator + ' "' + criterion.value + '"'
      }
      
      return ''
    },
    
    isCriterionValid(criterion) {
      if (!criterion) return false
      
      if (criterion.filterType === 'standard') {
        if (criterion.field === 'sport') {
          return criterion.sportIds && criterion.sportIds.length > 0
        }
        if (criterion.field === 'startTime') {
          return criterion.value !== '' && criterion.value !== null
        }
        return criterion.value !== '' && criterion.value !== null
      }
      
      if (criterion.filterType === 'odds') {
        return criterion.oddsValue !== null && criterion.oddsValue > 0
      }
      
      if (criterion.filterType === 'bookmaker') {
        return criterion.bookmakerIds && criterion.bookmakerIds.length > 0
      }
      
      if (criterion.filterType === 'event') {
        return criterion.numBookmakersValue !== null && criterion.numBookmakersValue > 0
      }
      
      return false
    },
    
    toggleExpanded() {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        this.displayCriteria = JSON.parse(JSON.stringify(this.activeCriteria))
        if (this.displayCriteria.length === 0) {
          this.displayCriteria.push(this.createEmptyCriterion())
        }
      }
    },
    
    addCriteriaRow() {
      this.displayCriteria.push(this.createEmptyCriterion())
      this.$forceUpdate()
    },
    
    removeCriteriaRow(index) {
      this.displayCriteria.splice(index, 1)
      if (this.displayCriteria.length === 0) {
        this.displayCriteria.push(this.createEmptyCriterion())
      }
      this.$forceUpdate()
    },
    
    removeCriterionAndRefresh(criterionId) {
      var index = this.activeCriteria.findIndex(function(c) { return c.id === criterionId })
      if (index !== -1) {
        this.activeCriteria.splice(index, 1)
        if (this.isExpanded) {
          this.displayCriteria = JSON.parse(JSON.stringify(this.activeCriteria))
          if (this.displayCriteria.length === 0) {
            this.displayCriteria.push(this.createEmptyCriterion())
          }
        }
        this.applyFilters()
      }
    },
    
    cancelFilters() {
      this.isExpanded = false
      this.displayCriteria = JSON.parse(JSON.stringify(this.activeCriteria))
    },
    
    async applyFilters() {
      // Apply the display criteria to the active criteria
      this.activeCriteria = JSON.parse(JSON.stringify(this.displayCriteria))
      this.isExpanded = false
      
      const validCriteria = this.activeCriteria.filter(c => this.isCriterionValid(c))
      
      if (validCriteria.length === 0) {
        this.filteredData = []
        return
      }
      
      this.isLoading = true
      const startTime = performance.now()
      
      try {
        // Build the filters array
        const filters = []
        
        for (var idx = 0; idx < validCriteria.length; idx++) {
          const criterion = validCriteria[idx]
          
          const filterObj = {
            index: idx,
            type: criterion.filterType,
            logicalOperator: criterion.logicalOperator
          }
          
          if (criterion.filterType === 'standard') {
            filterObj.field = criterion.field
            if (criterion.field === 'sport') {
              filterObj.operator = 'in'
              filterObj.value = criterion.sportIds
            } else if (criterion.field === 'startTime') {
              filterObj.operator = criterion.operator
              filterObj.value = criterion.value
            } else {
              filterObj.operator = criterion.operator
              filterObj.value = criterion.value
            }
          }
          else if (criterion.filterType === 'odds') {
            filterObj.oddsOperator = criterion.oddsOperator
            filterObj.oddsValue = criterion.oddsValue
          }
          else if (criterion.filterType === 'bookmaker') {
            filterObj.bookmakerOperator = criterion.bookmakerOperator
            filterObj.bookmakerIds = criterion.bookmakerIds
          }
          else if (criterion.filterType === 'event') {
            filterObj.eventProperty = 'numBookmakers'
            filterObj.eventOperator = criterion.eventOperator
            filterObj.numBookmakersValue = criterion.numBookmakersValue
          }
          
          filters.push(filterObj)
        }
        
        // Create the params array with name/value pairs
        const paramsArray = [
          {
            Name: "json",
            Value: JSON.stringify(filters)
          }
        ]
        
        console.log(JSON.stringify(filters))
        
        const paramsJson = JSON.stringify(paramsArray)
        
        // POST to WCF service
        const response = await fetch(this.wcfUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            SPName: "betfinder",
            Params: paramsJson
          })
        })
        
       

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const result = await response.json()
        
        debugger

       
       let data = JSON.parse(result.RetrieveGenericPostResult);


        // // Parse the result
        // let data = result
        //if (typeof result === 'string') {
        //  data = JSON.parse(result)
        //}
        
        if (data && data.d) {
          data = JSON.parse(data.d)
        }
        
        this.filteredData = data || []
        this.lastFilterTime = Math.round(performance.now() - startTime)
        
      } catch (error) {
        console.error('Filter error:', error)
        this.filteredData = []
        this.$emit('error', error.message)
      } finally {
        this.isLoading = false
      }
    },
    
    formatDateTime(dateTime) {
      if (!dateTime) return 'TBD'
      var date = new Date(dateTime)
      return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    clearFilters() {
      this.activeCriteria = []
      this.displayCriteria = [this.createEmptyCriterion()]
      this.filteredData = []
      this.lastFilterTime = null
      this.isExpanded = false
    }
  }
}
</script>

<style scoped>
.filter-app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

.filter-bar {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 20px;
  overflow: hidden;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.filter-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.filter-count {
  background: #4CAF50;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 4px;
}

.filter-actions {
  display: flex;
  gap: 8px;
}

.icon-btn {
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  border-radius: 6px;
  color: #6c757d;
  transition: all 0.2s;
}

.icon-btn:hover {
  background: #e9ecef;
  color: #495057;
}

.icon-btn.apply:hover {
  color: #4CAF50;
}

.filter-chips {
  padding: 10px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  background: white;
}

.filter-chip {
  background: #e7f5ff;
  color: #1971c2;
  padding: 4px 8px 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.chip-remove {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #1971c2;
}

.chip-remove:hover {
  background: rgba(0,0,0,0.1);
}

.clear-all {
  background: none;
  border: none;
  color: #868e96;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
}

.clear-all:hover {
  color: #f03e3e;
}

.filter-builder {
  border-top: 1px solid #e9ecef;
}

.toggle-builder {
  width: 100%;
  padding: 10px 16px;
  background: white;
  border: none;
  text-align: left;
  color: #4CAF50;
  font-weight: 500;
  cursor: pointer;
  font-size: 13px;
}

.toggle-builder:hover {
  background: #f8f9fa;
}

.builder-content {
  padding: 12px 16px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.filter-row {
  margin-bottom: 12px;
}

.logic-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  margin-bottom: 6px;
}

.logic-badge.and {
  background: #e7f5ff;
  color: #1971c2;
}

.logic-badge.or {
  background: #fff3e0;
  color: #e8590c;
}

.filter-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.compact-select {
  padding: 6px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: white;
  font-size: 13px;
  cursor: pointer;
}

.compact-select.filter-type {
  min-width: 140px;
}

.compact-select.field {
  min-width: 120px;
}

.compact-select.operator {
  min-width: 90px;
}

.value-container {
  flex: 1;
  min-width: 150px;
}

.compact-input {
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
}

.multi-select {
  position: relative;
}

.compact-select.multi {
  height: auto;
  min-height: 80px;
}

.hint {
  font-size: 10px;
  color: #6c757d;
  display: block;
  margin-top: 4px;
}

.boolean-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.remove-chip {
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  font-size: 18px;
  padding: 0 4px;
}

.remove-chip:hover {
  color: #f03e3e;
}

.add-filter-btn {
  background: none;
  border: 1px dashed #adb5bd;
  padding: 6px 12px;
  border-radius: 6px;
  color: #6c757d;
  font-size: 12px;
  cursor: pointer;
  margin: 8px 0;
}

.add-filter-btn:hover {
  border-color: #4CAF50;
  color: #4CAF50;
}

.builder-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #dee2e6;
}

.btn-primary, .btn-secondary {
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background: #4CAF50;
  color: white;
}

.btn-primary:hover {
  background: #45a049;
}

.btn-secondary {
  background: #e9ecef;
  color: #495057;
}

.btn-secondary:hover {
  background: #dee2e6;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 4px;
}

.results-info {
  font-size: 14px;
  color: #6c757d;
}

.result-time {
  font-size: 12px;
  color: #adb5bd;
}

.data-container {
  position: relative;
  min-height: 300px;
}

.table-wrapper {
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.data-grid {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 14px;
}

.data-grid thead {
  background: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
}

.data-grid th {
  text-align: left;
  padding: 14px 16px;
  font-weight: 600;
  color: #495057;
  font-size: 13px;
}

.data-grid td {
  padding: 14px 16px;
  border-bottom: 1px solid #e9ecef;
  color: #495057;
}

.data-grid tbody tr:hover {
  background: #f8f9fa;
}

.loading-state, .empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  color: #adb5bd;
}

.spinner-small {
  width: 24px;
  height: 24px;
  border: 2px solid #e9ecef;
  border-top-color: #4CAF50;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin: 0 auto 12px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-state svg {
  margin-bottom: 16px;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .filter-app {
    padding: 12px;
  }
  
  .data-grid thead {
    display: none;
  }
  
  .data-grid tbody tr {
    display: block;
    margin-bottom: 16px;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: white;
  }
  
  .data-grid td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    border: none;
    border-bottom: 1px solid #f0f0f0;
  }
  
  .data-grid td:last-child {
    border-bottom: none;
  }
  
  .data-grid td::before {
    content: attr(data-label);
    font-weight: 600;
    font-size: 12px;
    color: #6c757d;
    margin-right: 16px;
  }
  
  .filter-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .compact-select {
    width: 100%;
  }
  
  .value-container {
    width: 100%;
  }
  
  .logic-badge {
    margin-bottom: 8px;
  }
}
</style>